<div class="not-found">
  <p class="text">404 | Not Found</p>
</div>
